<template>
  <nav class="bottom-nav">
    <RouterLink
      v-for="item in items"
      :key="item.path"
      :to="item.path"
      class="bn-item"
      active-class="bn-active"
      :exact-active-class="item.path === '/' ? 'bn-active' : ''"
    >
      <component :is="item.icon" class="bn-icon" />
      <span class="bn-label">{{ item.label }}</span>
    </RouterLink>
  </nav>
</template>

<script setup lang="ts">
import { h } from "vue";
import { RouterLink } from "vue-router";

/** Inline SVG icons — single-color via currentColor so brand-green active
 *  state propagates through CSS without separate icon assets. */
const HomeIcon = () =>
  h("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2, "stroke-linecap": "round", "stroke-linejoin": "round" }, [
    h("path", { d: "M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1V9.5z" }),
  ]);

const PinIcon = () =>
  h("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2, "stroke-linecap": "round", "stroke-linejoin": "round" }, [
    h("path", { d: "M12 22s7-7.5 7-13a7 7 0 1 0-14 0c0 5.5 7 13 7 13z" }),
    h("circle", { cx: 12, cy: 9, r: 2.5 }),
  ]);

const QrIcon = () =>
  h("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2, "stroke-linecap": "round", "stroke-linejoin": "round" }, [
    h("rect", { x: 3, y: 3, width: 7, height: 7, rx: 1 }),
    h("rect", { x: 14, y: 3, width: 7, height: 7, rx: 1 }),
    h("rect", { x: 3, y: 14, width: 7, height: 7, rx: 1 }),
    h("path", { d: "M14 14h3v3M20 14v3M14 20h3M20 20v.01" }),
  ]);

const TicketIcon = () =>
  h("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2, "stroke-linecap": "round", "stroke-linejoin": "round" }, [
    h("path", { d: "M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4V8z" }),
    h("path", { d: "M9 6v12", "stroke-dasharray": "2 2" }),
  ]);

const UserIcon = () =>
  h("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2, "stroke-linecap": "round", "stroke-linejoin": "round" }, [
    h("circle", { cx: 12, cy: 8, r: 4 }),
    h("path", { d: "M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" }),
  ]);

const items = [
  { path: "/", label: "首頁", icon: HomeIcon },
  { path: "/bars", label: "找店家", icon: PinIcon },
  { path: "/wall", label: "我的條碼", icon: QrIcon },
  { path: "/wallet", label: "票夾", icon: TicketIcon },
  { path: "/me", label: "會員", icon: UserIcon },
];
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background: var(--bg-black);
  border-top: 1px solid var(--border-mute);
  padding: 8px 0 calc(8px + env(safe-area-inset-bottom));
  z-index: 100;
}

.bn-item {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
  color: var(--text-mute);
  text-decoration: none;
  font-size: 12px;
}

.bn-icon {
  width: 24px;
  height: 24px;
}

.bn-active {
  color: var(--brand-green);
}

.bn-label {
  line-height: 1;
}
</style>
